export default {"src":"/_next/static/media/Checkmark-disabled.060f8429.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};